
/* メインビジュアルスライダー  */
$(document).ready(function(){
  
  
  var $slider = $('.slider-mainvisual');
  $('.slider-mainvisual').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    dots: true,
    arrows: true,
    centerMode: true,
    centerPadding: '20%',
    responsive:[
      {
        breakpoint: 1024,
        settings:{
          adaptiveHeight: true,
          variableWidth: false,
        }
      },
      {
        breakpoint: 768,
        settings:{
          adaptiveHeight: true,
          variableWidth: false,
          centerMode: false,
        }
      },
      {
        breakpoint: 480,
        settings:{
          adaptiveHeight: true,
          variableWidth: false,
          centerMode: false,
        }
      },
    ]

    });
    $slider.on('beforeChange', function(slick, currentSlide, nextSlide){
     $('.articlebox-mainvisual-slider .emary-01').css('opacity','0');        
    });    
    $slider.on('afterChange', function(slick, currentSlide){
     $('.articlebox-mainvisual-slider .emary-01').css('opacity','1');
    });
});

      

/* 特集スライダー  */

$(document).ready(function(){            
    if($('.slider-article .item').size() > 4){

      var width = $(window).width();
      if(width <= 767){            
          /* $('.slider-article').slick('unslick'); */
      } else {
          $('.slider-article').slick({
            infinite: true,
            autoplay: false,
            speed: 500,	    
            dots: false,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: true,
          });                   
      }

    }                  
});

        
      